import { render, staticRenderFns } from "./RefundGoods.vue?vue&type=template&id=30c895d3&scoped=true&"
import script from "./RefundGoods.vue?vue&type=script&lang=js&"
export * from "./RefundGoods.vue?vue&type=script&lang=js&"
import style0 from "./RefundGoods.vue?vue&type=style&index=0&id=30c895d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c895d3",
  null
  
)

export default component.exports